export default "__VITE_ASSET__8e8b72ba__"